<template>
  <section 
    class="container-fluid Jumbotron"
    :style="{ backgroundImage: 'url(' + imgPath + ')' }">
    <header class="container TitleCard">
      <div class="row Emerge--fadeIn--slow" data-emergence="hidden">
        <div class="col-md-10 col-lg-8">
          <slot name="subtitle"/> 
        </div>
        <div class="col-md-7">
          <slot name="title"/>
          <portal-target name="modal-button"/>
        </div>
      </div>
    </header>
  </section>
</template>

<script>
export default {
  props: {
    imgPath: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/styles/_variables.scss';

.Jumbotron {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  min-height: 100vh;
}

.TitleCard {
  color: $colorWhite;
  margin-bottom: 3em;
  z-index: 1;
}

.TitleCard-subtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 1.25em;
  font-weight: 400;
  letter-spacing: .5px;
}

.TitleCard-title {
  font-family: 'Poppins', sans-serif;
  font-size: 2em;
  font-weight: 600;
  line-height: 1.25em;
  margin-bottom: .75em;
  @media screen and (min-width: $grid-sm) {
    font-size: 2.5em;
  }
  @media screen and (min-width: $grid-md) and (min-height: 960px) {
    font-size: 3em;
  }
  @media screen and (min-width: $grid-lg) {
    font-size: 3.75em;
  }
  @media screen and (min-width: $grid-xl) {
    font-size: 4em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Jumbotron.vue